import { css } from 'styled-components';
import { BreakpointQueryName } from '../../theme/breakpoints';
import { TypographyName } from '../../theme/typography';
import { getTypography } from '../../theme/utils';
export const baseStyle = _ref => {
  let {
    theme,
    $type
  } = _ref;
  return css(["", " padding:", " 3rem ", " ", ";font-weight:500;color:", ";background-color:", ";height:2rem;box-sizing:border-box;display:inline-flex;align-items:center;position:relative;&::after{content:'';width:0;height:0;border:1rem solid transparent;border-left-color:", ";;position:absolute;top:0;right:0;transform:translateX(100%);}", "{height:2.5rem;&::after{border-width:1.25rem;}}"], getTypography(theme, TypographyName.H4), theme.spaceUnits.mobile.SMALLEST, theme.spaceUnits.mobile.SMALLEST, theme.spaceUnits.mobile.SMALL, theme.palettes.neutrals.lightest, theme.palettes.energy[$type], theme.palettes.energy[$type], theme.breakpoints.up(BreakpointQueryName.MD));
};
//# sourceMappingURL=EnergyLabel.style.js.map